export default "__VITE_ASSET__BmpHeLwa__"